<template>
    <el-dialog title="添加子管理员" append-to-body :visible.sync="addSubAdminDialog" width="520px" :before-close="handleDialogClose" :close-on-click-modal="false" class="custom-form-dialog">
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top">
            <el-form-item label="选择子管理员" prop="sub_uid">
                <el-select v-model="formData.sub_uid" :remote-method="getUserList"  value collapse-tags  filterable  placeholder="请选择人员，可输入人员姓名搜索"  remote  size="small">
                    <el-option :key="user.uid"  :label="user.name"  :value="user.uid"    v-for="user in userList">
                    </el-option>
                </el-select>
            </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" :disabled="BtnDisabled" @click.stop="handleDialogConfirm" >确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { GetUserList,addSubAdmin } from "@/api/index.js"
export default {
    name:'add_sub_admin',
    props: {
        addSubAdminDialog: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            BtnDisabled:false,
            formData: {
                sub_uid: "",
            },
            formRules: {
                sub_uid: [ {required: true, message: "请选择子管理员"} ]
            },
            userList:[]
        }
    },
    created() {
        this.getUserList()
    },
    methods: {
        //获取用户列表
        getUserList(keyword) {
            GetUserList({keyword}).then(res => {
                if (res.code === 200) {
                    this.userList = res.data || []
                } else {
                    this.$toast(res.message)
                }
            })
        },
        handleDialogClose() {
            this.$emit("update:addSubAdminDialog", false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    let postData = {
                        sub_uid: this.formData.sub_uid
                    }
                    addSubAdmin(postData).then(res=> {
                        if(res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '添加成功',
                                duration: 1500,
                                onClose: () => {
                                    this.handleDialogClose()
                                    this.$emit('success')
                                    this.BtnDisabled = false
                                }
                            })
                        }else{
                            this.BtnDisabled = false
                        }
                    })

                }
            })
        },

    }
}
</script>
